import { BUSINESS_UNIT_ENDPOINT } from "./businessUnit/endpoint";
import { CORPORATION_ENDPOINT } from "./corporation/endpoint";
import { MANAGEMENT_ENDPOINTS } from "./management/endpoint";
import { USER_ENDPOINT } from "./user/endpoint";

export const ENDPOINT = {
  USER: USER_ENDPOINT,
  CORPORATION: CORPORATION_ENDPOINT,
  BU: BUSINESS_UNIT_ENDPOINT,
  MANAGEMENT: MANAGEMENT_ENDPOINTS,
};
